import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const CHANNEL_NAME = "admin-presence";

/**
 * Subscribes to admin presence channel and returns whether any admin is online.
 * Defers subscription by 3 seconds to avoid blocking initial page paint.
 */
export function useAdminOnline() {
  const [adminOnline, setAdminOnline] = useState(false);

  useEffect(() => {
    let channel: ReturnType<typeof supabase.channel> | null = null;

    const timeout = setTimeout(() => {
      if (typeof navigator !== "undefined" && navigator.onLine === false) return;
      channel = supabase.channel(CHANNEL_NAME);

      channel
        .on("presence", { event: "sync" }, () => {
          const state = channel!.presenceState();
          const hasAdmin = Object.values(state).some((presences) =>
            (presences as any[]).some((p) => p.role === "admin")
          );
          setAdminOnline(hasAdmin);
        })
        .subscribe();
    }, 4000);

    return () => {
      clearTimeout(timeout);
      if (channel) {
        supabase.removeChannel(channel);
      }
    };
  }, []);

  return adminOnline;
}
